<template>
  <div :class="['editor-wrapper', { 'has-content': content }]" :style="{ width: width, height: height }">
    <ckeditor
      :editor="editor"
      :config="editorConfig"
      @input="onEditorInput"
      v-model="content"
    ></ckeditor>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'editor-ck',
  props: {
    placeholder: String,
    credits: String,
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '500px'
    }
  },
  data () {
    return {
      content: '',
      backgroundColor: '#333',
      textColor: '#ddd',
      editor: ClassicEditor,
      editorConfig: {
        theme: 'lark',
        placeholder: this.placeholder,
        extraPlugins: [this.spacebarPlugin],
        toolbar: {
          items: ['heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'link', '|', 'undo', 'redo'],
          shouldNotGroupWhenFull: true
        }
      }
    }
  },
  mounted () {
    this.editorConfig.placeholder = this.placeholder
    this.content = this.credits
  },
  methods: {
    focusEditor () {
      this.$refs.ckeditor.editorInstance.editing.view.focus()
    },
    onEditorInput (event) {
      this.$emit('content-change', event)
      if (this.content !== '') this.editorConfig.placeholder = ''
    },
    spacebarPlugin (editor) {
      editor.keystrokes.set('space', (data, cancel) => {
        console.log('Funciono?', editor.model.document.selection.focus.stickiness)
        if (editor.model.document.selection.focus.stickiness === 'toNone') {
          editor.model.change(writer => {
            writer.insertText(' ', editor.model.document.selection.getFirstPosition())
          })
        } else {
          editor.model.change(writer => {
            let selectedRanges = editor.model.document.selection.getFirstRange()
            for (const item of selectedRanges.getItems()) {
              writer.remove(item)
              writer.insertText(' ', editor.model.document.selection.getFirstPosition())
            }
          })
        }
        return false
      })
    }
  }
}
</script>

<style>
@import '~@/variables.scss';
.editor-wrapper {
  position: relative;
  font-family: Arial, sans-serif;
}

</style>



// WEBPACK FOOTER //
// src/components/textEditor/EditorCK.vue